<template>
  <v-layout>
    <v-card width="717" ref="form">
      <v-card-title>
        Billing Address
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-text-field
            color="black"
            ref="name"
            v-model="name"
            :rules="[() => !!name || 'This field is required']"
            :error-messages="errorMessages"
            label="Full Name"
            placeholder="John Doe"
            required
        ></v-text-field>
        <v-text-field
            color="black"
            ref="companyName"
            v-model="companyName"
            label="Company Name"
            placeholder="Abc Inc"
            required
        ></v-text-field>
        <!--        auto select address-->
        <div class="subtitle-2 mt-2">Auto-fill location</div>
        <locations-autocomplete class="mb-2" @locationFound="addressFound"></locations-autocomplete>
        <v-divider></v-divider>
        <v-text-field
            class="mt-2"
            color="black"
            ref="address"
            v-model="address"
            :rules="[
              () => !!address || 'This field is required',
              () => !!address && address.length <= 25 || 'Address must be less than 25 characters',
              addressCheck
            ]"
            label="Address Line"
            placeholder="Snowy Rock Pl"
            counter="25"
            required
        ></v-text-field>
        <v-text-field
            ref="city"
            color="black"
            v-model="city"
            :rules="[() => !!city || 'This field is required', addressCheck]"
            label="City"
            placeholder="El Paso"
            required
        ></v-text-field>
        <v-text-field
            ref="state"
            color="black"
            v-model="state"
            :rules="[() => !!state || 'This field is required']"
            label="State/Province/Region"
            required
            placeholder="TX"
        ></v-text-field>
        <v-text-field
            ref="zip"
            v-model="zip"
            color="black"
            :rules="[() => !!zip || 'This field is required']"
            label="ZIP / Postal Code"
            required
            placeholder="79938"
        ></v-text-field>
        <country-select
            class="mt-2 mb-2 subtitle-1"
            v-model="country"
            :country="country"
            topCountry="CA"
            countryName
            autocomplete
        />
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-btn  text @click="resetForm">
          <v-icon>refresh</v-icon> reset
        </v-btn>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            class="white--text blue"
            text
            block
            @click="submit"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>

</template>
<script>
import {setDoc, doc, getDoc} from "firebase/firestore";

export default {
  data: () => ({
    errorMessages: '',
    name: null,
    companyName: null,
    address: null,
    city: null,
    state: null,
    zip: null,
    country: null,
    formHasErrors: false,
    selectedAddress: ''
  }),
  computed: {
    form() {
      return {
        name: this.name,
        address: this.address,
        city: this.city,
        state: this.state,
        zip: this.zip,
        country: this.country
      }
    },
    user() {
      return this.$store.getters.user
    },
    error() {
      return this.$store.getters.error
    },
    loading() {
      return this.$store.getters.loading
    }
  },
  created() {
    if (this.user) {
      let db = this.$store.state.db
      let billingAddressRef = doc(db, 'users', this.user.uid, 'billing', 'billingAddress')
      return getDoc(billingAddressRef)
          .then (doc =>{
            let data = doc.data()
            // console.log(data)
            if (data) {
              this.$store.dispatch('setBillingAddress', data)
              this.name = data.name
              this.address = data.address
              this.city = data.city
              this.state = data.state
              this.zip = data.zip
              this.country = data.country
              this.companyName = data.companyName
            }
          })
    }

  },
  watch: {
    name() {
      this.errorMessages = ''
    }

  },
  methods: {
    addressFound(local) {
      console.log(local)
      let locals = local.formatted_address.split(',')

      if (locals.length > 1) {
        this.address = locals[0]
        this.city = locals[1]
        this.country = locals[3]

        let codes = locals[2].split(' ')
        this.state = codes[1]
        this.zip = codes[2] + ' ' + codes[3]

        // console.log(codes)
      }
    },
    onDismissed() {
      this.$store.dispatch('clearError')
    },

    addressCheck() {
      this.errorMessages = this.address && !this.name
          ? `Hey! I'm required`
          : ''
      return true
    },
    resetForm() {
      this.errorMessages = []
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if(this.$refs[f]) this.$refs[f].reset()
      })
    },
    submit() {
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true
        if(this.$refs[f]) this.$refs[f].validate(true)
      })
      if (!this.formHasErrors) {
        let db = this.$store.state.db
        return setDoc(doc(db, 'users', this.user.uid, 'billing', 'billingAddress'),
            {...this.form, companyName: this.companyName})
        .catch(err => {
          this.$store.dispatch('setError', err)
        })

      }

    }


  }

}
</script>